module.exports = __webpack_public_path__ + "img/airbus.56e4a78b.svg";